module.exports = __webpack_public_path__ + "static/29-d5ad31fefdeb65b50965ec44d65154b1.gif";